import React from 'react'
import { Button, Grid, Typography } from '@material-ui/core'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

export const OperacionFinDeLlenadoView = ({
  silo: { nombreCorto: nombre },
  aceptar,
  cancelar
}) => (
  <Grid container spacing={4} direction='column' justify='space-around'>
    <Grid item xs={12} >
      <Typography variant='h6'>Atención</Typography>
    </Grid>
    <Grid item xs={12} >
      <Typography variant='h6'>¿Seguro que desea finalizar el llenado de <strong>{nombre}</strong>?</Typography>
    </Grid>
    <Grid container spacing={3} item xs={12} justify='space-between'>
      <Grid item xs='auto'>
        <Button
          variant='contained'
          onClick={cancelar}
          startIcon={<HighlightOffIcon />}
          color='secondary'>
            Cancelar
        </Button>
      </Grid>
      <Grid item xs='auto'>
        <Button
          variant='contained'
          onClick={aceptar}
          startIcon={<CheckCircleOutlineIcon />}
          color='primary'>
            Aceptar
        </Button>
      </Grid>
    </Grid>
  </Grid>
)
